import { render, staticRenderFns } from "./BookingsBan.vue?vue&type=template&id=0efe1df3&scoped=true"
import script from "./BookingsBan.vue?vue&type=script&lang=js"
export * from "./BookingsBan.vue?vue&type=script&lang=js"
import style0 from "./BookingsBan.vue?vue&type=style&index=0&id=0efe1df3&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0efe1df3",
  null
  
)

export default component.exports